import gsap from "gsap";

export function initPageLoader() {
  (function ($) {
    class Preloader {
      constructor() {
        this.$body = $("body");
        this.$preloader = $("#preloader");
        this.$animationContainer = $(".preloader__content");
        this.$panels = $(".preloader__blind");
        if (!this.$preloader.length) return;

        this.isAnimating = false;
        this.init();
      }

      init() {
        this.$body.css("overflow", "hidden");
        window.scrollTo(0, 0);

        $(".preloader__letter").each(function (index) {
          const delay = index * 0.2;
          $(this).css("animation-delay", `${delay}s`);
          $(this).addClass("letter-animate");
        });

        const startExit = () => this.animateOut();

        if (document.readyState === "complete") {
          // If loaded instantly, still wait a bit for text animation
          setTimeout(startExit, 1000);
        } else {
          $(window).on("load", () => {
            // Wait minimal time after load to ensure smooth transition
            setTimeout(startExit, 1000);
          });
        }

        setTimeout(() => {
          if (this.$preloader.is(":visible")) {
            startExit();
          }
        }, 1000);
      }

      animateOut() {
        if (this.isAnimating) return;
        this.isAnimating = true;

        const tl = gsap.timeline({
          onComplete: () => {
            this.$preloader.remove();
            this.$body.css("overflow", "");
          },
        });

        tl.to(
          this.$animationContainer[0],
          {
            opacity: 0,
            duration: 1.16, // ← Match the total blind animation time
            ease: "power2.out",
          },
          0,
        );

        tl.to(
          this.$panels.toArray(),
          {
            scaleX: 0,
            duration: 0.8,
            transformOrigin: "right",
            stagger: {
              each: 0.12, // 4 panels: 1s + (0.12 × 3) = 1.16s total
              from: "start",
            },
            ease: "power4.inOut",
          },
          0,
        );
      }
    }

    $(() => new Preloader());
  })(jQuery);
}
